export interface GopherGlyphProps {
  size?: number;
}

/** Gopher line glyph (24px viewBox, 1.5px stroke, currentColor). Replaces the sparkle icon. */
export function GopherGlyph({ size = 16 }: GopherGlyphProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <ellipse cx="12" cy="19" rx="9.5" ry="2.2" />
      <path d="M5.6 18.4V13a6.4 6.4 0 0 1 12.8 0v5.4" />
      <path d="M6.4 9.4a2 2 0 1 1 2.5-2.6" />
      <path d="M17.6 9.4a2 2 0 1 0-2.5-2.6" />
      <circle cx="9.4" cy="12.4" r="0.9" fill="currentColor" stroke="none" />
      <circle cx="14.6" cy="12.4" r="0.9" fill="currentColor" stroke="none" />
      <path d="M10.7 14.6h2.6L12 16z" fill="currentColor" stroke="none" />
      <path d="M12 16v1.4" />
    </svg>
  );
}
